import { connect } from 'react-redux';
import { downloadAttachment, downloadVideoImageAttachment } from '../../actions/chatActions';

import AttachmentView from './';

const mapStateToProps = (state, ownProps) => {
  const attachmentId = ownProps.attachmentId ? ownProps.attachmentId : ownProps.match.params.attachmentId;
  const attachment = state.attachments[attachmentId] ? state.attachments[attachmentId] : {};
  return {
    attachmentId,
    attachment
  }
};

const mapDispatchToProps = dispatch => ({
  downloadAttachment: attachmentId => dispatch(downloadAttachment(attachmentId)),
  downloadVideoImageAttachment: attachmentId => dispatch(downloadVideoImageAttachment(attachmentId))
});

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentView);
